export default "__VITE_ASSET__YT5OpXzU__"